'use client'

import { GlobalTypography, ProductReviewsBlock } from 'cms-types'

import { ProductVariant } from '../../types'
import ReviewsWidget from './ReviewsWidget'

type ProductReviewsUIProps = ProductReviewsBlock & {
  selectedVariant: ProductVariant | undefined
  typography: GlobalTypography['productPage']
  reviewsStore: string
}

function ProductReviews({ selectedVariant, typography, reviewsStore }: ProductReviewsUIProps) {
  const { title, fromText, verifiedCustomerText } = typography.reviewsBlock

  return (
    <ReviewsWidget
      id='product-reviews'
      reviews={selectedVariant?.reviews}
      reviewsUrl={`https://www.reviews.io/product-reviews/store/${reviewsStore}/${selectedVariant?.sku}`}
      title={title}
      reviewsText={typography.reviewsText}
      fromText={fromText}
      verifiedCustomerText={verifiedCustomerText}
    />
  )
}

export default ProductReviews
